import { useRouter } from "next/router";

import { Link } from "@chakra-ui/next-js";
import { Tab, TabList, Tabs, Tooltip } from "@chakra-ui/react";

export interface HeaderTab<T> {
  label: string;
  slug: T;
  path?: string;
  isDisabled?: boolean;
  disabledTooltip?: string;
}

export interface HeaderTabsProps<T> {
  basePath?: string;
  tabs: ReadonlyArray<HeaderTab<T>>;
  selectedTab?: T;
}
function HeaderTabs<T extends string>({ basePath, selectedTab: propSelectedTab, tabs }: HeaderTabsProps<T>) {
  const { pathname } = useRouter();
  const linkPathTemplate = pathname.split("/").slice(0);
  const lastRouteParam = linkPathTemplate[linkPathTemplate.length - 1];
  const isOverview = !!lastRouteParam.match(/\[.*]/);
  const selectedTab = isOverview ? "" : lastRouteParam;

  const selectedIndex = tabs.findIndex(tab => tab.slug === (propSelectedTab ?? selectedTab));
  return (
    <Tabs isLazy index={selectedIndex}>
      <TabList borderBottom="none">
        {tabs.map((tab, index) => {
          const newSlug = tabs[index].slug;
          const additionalPath = tabs[index].path ? `/${tabs[index].path}` : "";
          const href = `${basePath}/${newSlug}${additionalPath}`;

          // Check if tab is disabled
          const isDisabled = tab.isDisabled || !basePath;
          const disabledTooltip = tab.disabledTooltip || "Create an environment first";

          const tabElement = (
            <Tab
              key={newSlug}
              isDisabled={isDisabled}
              px={8}
              {...(!isDisabled && basePath ? { as: Link, href } : {})}
            >
              {tab.label}
            </Tab>
          );

          // Wrap in tooltip if disabled with custom reason
          return tab.isDisabled ? (
            <Tooltip key={newSlug} label={disabledTooltip}>
              {tabElement}
            </Tooltip>
          ) : (
            tabElement
          );
        })}
      </TabList>
    </Tabs>
  );
}

export default HeaderTabs;
